export const drug_name_list = {
    "ACETAZOLAMIDE": "ACETAZOLAMIDE 250MG TAB.",
    "ALPHAGAN": "ALPHAGAN P 5ML",
    "ANME": "ANME 0.5% 0.5ML",
    "AZOPT": "AZOPT 5ML",
    "CARTOLOL": "CARTOLOL 2% 5ML",
    "COMBIGAN": "COMBIGAN 5ML",
    "COSOPT": "COSOPT 5ML",
    "EYBELIS": "EYBELIS 20MCG 2.5ML",
    "ISOPTO": "ISOPTO 2% 15ML",
    "IZBA": "IZBA 30UG 2.5ML",
    "LATAN": "LATAN 2.5ML",
    "LATANOPROST": "LATANOPROST 2.5ML",
    "LUMIGAN": "LUMIGAN (單支) 30支",
    "LUMIGAN1": "LUMIGAN (單瓶) 3ML",
    "MANNITOL": "MANNITOL 100ML",
    "SIMBRINZA": "SIMBRINZA 5ML",
    "SPIROTONE": "SPIROTONE 25 TAB.",
    "TIMOLOL": "TIMOLOL 0.5% 5ML",
    "TRUSOPT": "TRUSOPT 5ML",
    "VYZULTA": "VYZULTA 2.5ML",
    "XALATAN": "XALATAN 2.5ML"
};

export const drugTransList = {
    "ACETAZOLAMIDE": "乙醯胺基硫唑嘧",
    "ALPHAGAN": "艾弗目P",
    "ANME": "眼明",
    "AZOPT": "愛舒壓",
    "CARTOLOL": "凱特羅",
    "COMBIGAN": "康皕庚",
    "COSOPT": "康舒目",
    "EYBELIS": "愛倍力",
    "ISOPTO": "愛舒特開明",
    "IZBA": "易舒壓",
    "LATAN": "拉坦素",
    "LATANOPROST": "諾而坦",
    "LUMIGAN": "露明目(單支)",
    "LUMIGAN1": "露明目(單瓶)",
    "MANNITOL": "安露",
    "SIMBRINZA": "勝克壓",
    "SPIROTONE": "愛達信",
    "TIMOLOL": "克壓",
    "TRUSOPT": "舒露瞳",
    "VYZULTA": "凡視達",
    "XALATAN": "舒而坦"
};

export const simpDrug = {
    "ACETAZOLAMIDE": "ACET",
    "ALPHAGAN": "ALPH",
    "ANME": "ANME",
    "AZOPT": "AZOP",
    "CARTOLOL": "CAR2",
    "COMBIGAN": "COMB",
    "COSOPT": "COSO",
    "EYBELIS": "EYBE",
    "ISOPTO": "ISOP",
    "IZBA": "IZBA",
    "LATAN": "LATA",
    "LATANOPROST": "LATA2",
    "LUMIGAN": "LUMI",
    "LUMIGAN1": "LUM1",
    "MANNITOL": "MAN1",
    "SIMBRINZA": "SIMB",
    "SPIROTONE": "SPIR",
    "TIMOLOL": "TIMO",
    "TRUSOPT": "TRUS",
    "VYZULTA": "VYZU2",
    "XALATAN": "XALA"
};

export const chinese2Simp = {
    "乙醯胺基硫唑嘧": "ACET",
    "艾弗目P": "ALPH",
    "眼明": "ANME",
    "愛舒壓": "AZOP",
    "凱特羅": "CAR2",
    "康皕庚": "COMB",
    "康舒目": "COSO",
    "愛倍力": "EYBE",
    "愛舒特開明": "ISOP",
    "易舒壓": "IZBA",
    "拉坦素": "LATA",
    "諾而坦": "LATA2",
    "露明目(單支)": "LUMI",
    "露明目(單瓶)": "LUM1",
    "安露": "MAN1",
    "勝克壓": "SIMB",
    "愛達信": "SPIR",
    "克壓": "TIMO",
    "舒露瞳": "TRUS",
    "凡視達": "VYZU2",
    "舒而坦": "XALA"
};

const drugClassToColor = {Beta_blocker: "#ffe415", alpha2_agonists: "#a33af9", CAI: "#f89b0f", PG: "#0ff8c9", OPD: "#f53871", Combine: "#0f70f8", oral: "#2eef1d", bit: "#f538f5"}

export const drugColor = {
    "ACETAZOLAMIDE": [drugClassToColor.CAI],
    "ALPHAGAN": [drugClassToColor.alpha2_agonists],
    "ANME": [drugClassToColor.PG],
    "AZOPT": [drugClassToColor.CAI],
    "CARTOLOL": [drugClassToColor.PG],
    "COMBIGAN": [drugClassToColor.Beta_blocker, drugClassToColor.CAI],
    "COSOPT": [drugClassToColor.Beta_blocker, drugClassToColor.CAI],
    "EYBELIS": [drugClassToColor.PG],
    "ISOPTO": [drugClassToColor.OPD],
    "IZBA": [drugClassToColor.PG],
    "LATAN": [drugClassToColor.PG],
    "LATANOPROST": [drugClassToColor.PG],
    "LUMIGAN": [drugClassToColor.PG],
    "LUMIGAN1": [drugClassToColor.PG],
    "MANNITOL": [drugClassToColor.OPD],
    "SIMBRINZA": [drugClassToColor.alpha2_agonists, drugClassToColor.CAI],
    "SPIROTONE": [drugClassToColor.OPD],
    "TIMOLOL": [drugClassToColor.Beta_blocker],
    "TRUSOPT": [drugClassToColor.CAI],
    "VYZULTA": [drugClassToColor.PG, drugClassToColor.oral],
    "XALATAN": [drugClassToColor.PG]
}